const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "核聚变2025北京站"
const desc = "欢迎来玩"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  data: {
    newsTagId: "29737",
    // grpgUrl: "https://site.gcores.com/grpg/",
    ticketUrl: "https://show.bilibili.com/platform/detail.html?id=102863",
    // zhiyuanUrl: "https://www.gcores.com",
    topicUrl: "https://www.gcores.com/topics/9",
  },
}
